import React from 'react';
import { Grid, Box, Typography, Divider } from '@mui/material';
import { Select, Form } from 'antd';
import InputForm from "../../InputT";
import SearInputG from "../../SearchInput";
import CheckBox from "../../CheckBox";
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';

const { Option } = Select;

// Paramétrage des Picklists
const searchFourn: ParamsPicklist = { CodeAgence: '', Table: "Fournisseur", Colonne1: "CodeFournisseur", Colonne2: "RaisonSociale", Colagence: '101', Choix: 22 };
const searchPays: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre: 'RUBRIQ', valfiltre: 'PAYS', Choix: 22 };
const searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 };
const searchJuridique: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '', colfiltre: 'RUBRIQ', valfiltre: 'FORMEJURIDIQUE', Choix: 22 };

const Tab1 = (props: { 
    form?: any, 
    EtatG: boolean,
    disabledForm: boolean,
    sbmit: string
}) => {
    
    // Observation de la case "Est Client" pour activer/désactiver le champ référence
    const estClientValue = Form.useWatch('ESTCLIENT', props.form);

    return (
        <div className='tabItem'>
            <Grid container className='border' sx={{ width: "85%", position: "absolute", p: 2 }}>
                <legend>FICHE D'IDENTIFICATION ET DE CONFORMITÉ</legend>
                
                {/* --- COLONNE GAUCHE : LÉGAL --- */}
                <Grid item xs={12} md={6} lg={6} className='border-left' sx={{ pr: 2 }}>
                    
                    <Box sx={{ pointerEvents: props.sbmit === 'add' ? 'none' : 'auto' }}>
                        <SearchModal 
                            width={7} 
                            disabled={props.EtatG} 
                            notRequired 
                            form={props.form} 
                            Titre={'Recherche Fournisseur'} 
                            label={'ID Fournisseur'} 
                            name={'CODEFOURNISSEUR'} 
                            Parametre={searchFourn} 
                        />
                    </Box>

                    <InputForm 
                        width={7} 
                        label="Raison Sociale" 
                        type="texte" 
                        name="RAISONSOCIALE" 
                        disabled={props.disabledForm} 
                    />

                    <SearchModal 
                        width={7} 
                        form={props.form} 
                        Titre={'Forme Juridique'} 
                        label={'Forme Juridique'} 
                        name={'FORMEJURIDIQUE'} 
                        Parametre={searchJuridique} 
                        disabled={props.disabledForm} 
                    />

                    <SearchModal 
                        width={7} 
                        form={props.form} 
                        Titre={'Sélection Pays'} 
                        label={'Pays'} 
                        name={'CODEPAYS'}
                        Parametre={searchPays} 
                        disabled={props.disabledForm} 
                    />

                    <InputForm 
                        width={7} 
                        label="N° Contribuable" 
                        notRequired
                        type="texte" 
                        name="NUMCONTRIBUABLE" 
                        disabled={props.disabledForm} 
                    />
                </Grid>

                {/* --- COLONNE DROITE : CONTACT & SCREENING --- */}
<Grid item xs={12} md={6} lg={6} className='border-left' sx={{ pl: 2 }}>

    {/* 1. Champ Contact */}
    <InputForm
        width={7}
        label="Contact"
        type="texte"
        name="CONTACT"
        disabled={props.disabledForm}
    />

    {/* 2. Champ Screening (aligné sur le même mécanisme que InputForm) */}
    <Form.Item
        className='bordure'
        label="Screening Sharia"
        name="STATUTSCREENING"
        labelCol={{ span: 7, style: { whiteSpace: 'pre-wrap' } }}
    >
        <Select placeholder="Sélectionner" disabled={props.disabledForm} style={{ width: '100%' }}>
            <Option value="EN_ATTENTE">EN ATTENTE</Option>
            <Option value="VALIDE">VALIDÉ</Option>
            <Option value="REJETE">REJETÉ</Option>
            <Option value="DOUTEUX">DOUTEUX</Option>
        </Select>
    </Form.Item>

    <Box
    sx={{
        ml: `${(3 / 24) * 100}%`,
        mt: 5, 
        mb: 1,
        display: 'flex',
        alignItems: 'left',
        gap: 4,
        '& .ant-form-item': { marginBottom: 0 },
    }}
>
    <CheckBox
        notRequired
        form={props.form}
        label="Actif dans le système"
        name="ESTACTIF"
        disabled={props.disabledForm}
    />

    <CheckBox
        notRequired
        form={props.form}
        label="Possède un compte client"
        name="ESTCLIENT"
        disabled={props.disabledForm}
    />
</Box>

    {/* 4. Champ Réf Client */}
    <SearInputG
        width={7}
        form={props.form}
        Titre={'Recherche Indice Client'}
        label={'Réf. Client'}
        name={'CODECLIENTREF'}
        Parametre={searchClient}
        notRequired
        dissabledCode={props.disabledForm || !estClientValue}
    />
</Grid>
            </Grid>
        </div>
    );
};

export default Tab1;